import React from 'react';
/**
 * The reference of the returned function will not change, and the values used inside are real time values.
 * @param callback function
 * @returns memorized function, reference will not change
 */

export default function useEvent(callback) {
  var fnRef = React.useRef();
  fnRef.current = callback; // eslint-disable-next-line react-hooks/exhaustive-deps

  var memoFn = React.useCallback(function () {
    var _fnRef$current;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}